/**
 * @type {Object}
 * @property {array}  data  Product data
 */
const initialState = {
    categoryData: [],
    activeCategory: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerCategory = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_CATEGORY_DATA':
            var { data } = action;
            var active_data = data?.filter(ele => ele.status === "Active")
            newState.categoryData = data;
            newState.activeCategory = active_data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerCategory;